import React, { CSSProperties } from 'react';
import styles from './style.module.scss';

export interface BadgeProps {
    children?: React.ReactNode;
    maxWidth?: CSSProperties['maxWidth'];
}

const Badge = ({ children, maxWidth = '30ch' }: BadgeProps) => {
    const text = (
        <span
            className={styles.badgeText}
            style={{
                maxWidth,
            }}
        >
            {children}
        </span>
    );

    return <div className={styles.badge}>{text}</div>;
};

export default Badge;
